var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgJsonfeed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 106 106"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5
}, /*#__PURE__*/React.createElement("path", {
  d: "m33.9 81.7.1.1c5.9-5.8 10.1-5.4 17.1 1.7l11.2 11.1c11.6 11.6 22.4 11 35.3-2l4-3.9-8.4-8.4-2 2c-7.4 7.4-12.5 7.5-19.5.4l-13-13c-6.8-6.7-13.5-7.4-19.9-2l-1.3-1.3c5.5-6.7 5-12.9-1.5-19.4L24.3 35.3c-7.2-7.1-7.1-12.1.3-19.5l2-2-8.4-8.4-3.9 4c-13 13-13.7 23.5-2.4 34.8l9.7 9.7c7 7 7.5 11.3 1.7 17.1A7.6 7.6 0 0 0 34 81.8z"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  transform: "rotate(-45 80 -34.8)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32.5,
  cy: 7.5,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57.5,
  cy: 7.5,
  r: 7.5
})))));

export default SvgJsonfeed;